import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import authReducer from "../reducers/auth";
import checksReducer from "../reducers/checks";
import filtersReducer from "../reducers/filters";
import probersReducer from "../reducers/probers";
import plansReducer from "../reducers/plans";
import fetchInProgress from "../reducers/fetchInProgress";
import loadingInProgress from "../reducers/loadingInProgress";
import financeReducer from "../reducers/finance";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const appReducer = combineReducers({
  auth: authReducer,
  checks: checksReducer,
  filters: filtersReducer,
  probers: probersReducer,
  finance: financeReducer,
  plans: plansReducer,
  fetchInProgress,
  loadingInProgress
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
